import React from "react";

const Footer = () => {
  return (
    <div className="">
      <div className="container my-6 mx-auto flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
        {/* Logo and Description */}
        <div className="flex items-center space-x-3">
          <img
            src="/arancia-logo.jpeg"
            alt="Arancia Logo"
            className="h-15 w-15"
          />
          {/* <h2 className="text-2xl font-bold text-light-green">
            Arancia Technologies
          </h2> */}
        </div>

        {/* Links Section */}
        <div className="flex space-x-8">
          <a href="#home" className="hover:text-light-green text-white text-lg">
            Home
          </a>
          <a
            href="#about"
            className="hover:text-light-green text-white text-lg"
          >
            About
          </a>
          <a
            href="#services"
            className="hover:text-light-green text-white text-lg"
          >
            Services
          </a>
          {/* <a
            href="#contact"
            className="hover:text-light-green text-white text-lg"
          >
            Contact
          </a> */}
        </div>

        {/* Social Media Icons */}
        <div className="flex space-x-6">
          <a href="#" className="hover:text-light-green">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="#" className="hover:text-light-green">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="#" className="hover:text-light-green">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>
      <div className="text-center text-sm text-gray-400 mt-6">
        <p className="pb-6">
          &copy; {new Date().getFullYear()} Arancia Technologies. All rights
          reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
